// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"breadcrumbs_Breadcrumbs__aGYyC","item":"breadcrumbs_item__NeOV7","more":"breadcrumbs_more__YkAil","Route":"breadcrumbs_Route__G6DX4"};